import {
  faEllipsis,
  faEdit,
  faSpinnerThird,
  faThumbTack,
  faTrashCan,
  faThumbTackSlash,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/DropdownMenu'
import { useTranslation } from 'services/i18n'
import { cn } from 'utils/cn'

import type { FC } from 'react'

type Props = {
  isPending: boolean
  isPinned?: boolean
  onEnableEditMode: VoidFunction
  onClickDelete: VoidFunction
  onCloseCallback: VoidFunction
  onPinConversation: VoidFunction
  onOpenChange: (isOpen: boolean) => void
}

export const ActionButtons: FC<Props> = ({
  isPending,
  isPinned,
  onEnableEditMode,
  onClickDelete,
  onCloseCallback,
  onPinConversation,
  onOpenChange,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation_history.conversation_action',
  })

  return (
    <DropdownMenu onOpenChange={onOpenChange}>
      <DropdownMenuTrigger>
        <FontAwesomeIcon
          icon={isPending ? faSpinnerThird : faEllipsis}
          className={cn({ 'animate-spin': isPending })}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        onCloseAutoFocus={(e) => {
          e.preventDefault()
          onCloseCallback()
        }}
      >
        <DropdownMenuItem onClick={onPinConversation}>
          <FontAwesomeIcon
            icon={isPinned ? faThumbTackSlash : faThumbTack}
            className="mr-2"
          />
          <span>{t(isPinned ? 'unpin' : 'pin')}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onEnableEditMode}>
          <FontAwesomeIcon icon={faEdit} className="mr-2" />
          <span>{t('rename')}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onClickDelete} className="text-danger">
          <FontAwesomeIcon icon={faTrashCan} className="mr-2" />
          <span>{t('delete')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
